
export default {
  props: {
    name: {
      type: String,
      default: () => '',
    },
    descricao: {
      type: String,
      default: () => '',
    },
  },
}
